module.exports = __webpack_public_path__ + "static/media/Blog.2ae49eaf.jpg";